import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const AuthTokenInput = () => {
  const [token, setToken] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (token.trim()) {
      navigate(`/survey/${token}`);
    }
  };

  return (
    <form 
      onSubmit={handleSubmit} 
      className="space-y-4 animate-slideUp"
      aria-label="Access code form"
    >
      <div className="flex flex-col items-center gap-4 sm:flex-row sm:gap-2">
        <Input
          type="text"
          placeholder="Ange din åtkomstkod"
          value={token}
          onChange={(e) => setToken(e.target.value)}
          className="w-full max-w-sm text-center sm:text-left"
          aria-label="Access code input"
          required
        />
        <Button 
          type="submit" 
          className="w-full sm:w-auto"
          aria-label="Continue with access code"
        >
          Fortsätt
        </Button>
      </div>
    </form>
  );
};